import {
  ChangeDetectionStrategy,
  Component,
  ComponentRef,
  ElementRef,
  OnDestroy,
  OnInit,
  Renderer2,
} from '@angular/core';
import { CmsBannerCarouselComponent, CmsComponent, CmsService, ContentSlotComponentData } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable, Subscription, combineLatest, of } from 'rxjs';
import { distinctUntilChanged, filter, map, shareReplay, switchMap, take } from 'rxjs/operators';
import { SdSimpleBannerComponent } from '../simple-banner';

@Component({
  selector: 'sd-random-banner',
  templateUrl: 'random-banner.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SdRandomBannerComponent implements OnInit, OnDestroy {
  banner$: Observable<ContentSlotComponentData>;
  subscription = new Subscription();

  constructor(
    private componentData: CmsComponentData<CmsBannerCarouselComponent>,
    private cmsService: CmsService,
    private renderer: Renderer2,
    private el: ElementRef,
  ) {}

  ngOnInit(): void {
    this.banner$ = this.componentData.data$.pipe(
      filter<CmsBannerCarouselComponent>(Boolean),
      map((data) => (data?.banners || '').trim()),
      distinctUntilChanged(),
      map((banners) => banners.split(' ').filter(Boolean)),
      switchMap((codes) => {
        // если список баннеров пуст, необходимо возвратить
        // пустой массив, чтобы перерисовать текущий баннер
        if (!codes.length) {
          return of([] as CmsComponent[]);
        }

        return combineLatest(codes.map((code: string) => this.cmsService.getComponentData(code).pipe(take(1))));
      }),
      // тут фильтруются баннеры на которых навешаны рестрикшены
      map((slides) => slides.filter((slide) => slide !== null)),
      map((slides) => {
        const randomIndex = Math.floor(Math.random() * slides.length);

        return slides[randomIndex];
      }),
      shareReplay({ bufferSize: 1, refCount: true }),
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  setRef(ref: ComponentRef<SdSimpleBannerComponent>): void {
    this.subscription.add(
      ref.instance.bannerClassEvent.subscribe((val: string) => {
        // Нельзя использовать @HostBinding('class'),
        // так как не рендерятся классы пока компонент не появится на экране
        // detectChanges не помогает. императивное изменение классов работает надежнее
        const classNames = val.split(' ');
        classNames.forEach((className: string) => {
          this.renderer.addClass(this.el.nativeElement, className);
        });
      }),
    );
  }
}
